import React from "react";
import { CheckCircle2, XCircle, Pencil } from "lucide-react";

const ReactionButtons = ({ activity, onReaction, onGradeClick, processing = false, currentUserEmail, fromSource = "Professor" }) => {
  const targetSource = fromSource || "Professor";
  const isHodContext = targetSource === "HOD";

  const userReaction = isHodContext
    ? activity?.reactions?.find((r) => r.from_source === "HOD")
    : activity?.reactions?.find((r) => r.from_source !== "HOD") || activity?.reactions?.find((r) => r.professorEmail === currentUserEmail);

  const isApproved = userReaction?.type === "✅" || userReaction?.decision === "Approved";
  const isRejected = userReaction?.type === "❌" || userReaction?.decision === "Rejected";
  const hasReaction = isApproved || isRejected;

  const handleApproveClick = () => {
    if (onGradeClick) {
      onGradeClick(activity, "Approved", targetSource);
    } else if (onReaction) {
      onReaction(activity, "Approved", targetSource);
    }
  };

  const handleRejectClick = () => {
    if (onGradeClick) {
      onGradeClick(activity, "Rejected", targetSource);
    } else if (onReaction) {
      onReaction(activity, "Rejected", targetSource);
    }
  };

  const handleEditClick = () => {
    const dec = isRejected ? "Rejected" : "Approved";
    if (onGradeClick) {
      onGradeClick(activity, dec, targetSource);
    } else if (onReaction) {
      onReaction(activity, dec, targetSource);
    }
  };

  return (
    <div className="w-full">
      {hasReaction ? (
        <div className="grid grid-cols-2 gap-3 w-full">
          {isApproved ? (
            <span className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold text-xs bg-emerald-100 text-emerald-800 border border-emerald-300 shadow-xs w-full">
              <CheckCircle2 className="w-4 h-4 text-emerald-600" />
              <span>{isHodContext ? "HOD Approved ✅" : "Approved ✅"}</span>
            </span>
          ) : (
            <span className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-rose-100 text-rose-800 font-bold text-xs border border-rose-300 shadow-xs w-full">
              <XCircle className="w-4 h-4 text-rose-600" />
              <span>{isHodContext ? "HOD Rejected ❌" : "Rejected ❌"}</span>
            </span>
          )}

          <button
            onClick={handleEditClick}
            disabled={processing}
            className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-300 transition-all shadow-xs w-full cursor-pointer"
            title={isHodContext ? "Edit HOD Reaction & Grade Details" : "Edit Reaction & Grade Details"}
          >
            <Pencil className="w-4 h-4 text-slate-600" />
            <span>{isHodContext ? "Edit HOD Reaction" : "Edit Reaction / Grade"}</span>
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3 w-full">
          <button
            onClick={handleApproveClick}
            disabled={processing}
            className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold text-xs transition-all border shadow-xs w-full cursor-pointer ${
              isHodContext
                ? "bg-purple-50 text-purple-700 hover:bg-purple-100 border-purple-300"
                : "bg-emerald-50 text-emerald-700 hover:bg-emerald-100 border-emerald-300"
            } ${processing ? "opacity-50 cursor-not-allowed" : ""}`}
            title={isHodContext ? "HOD Approve Activity (Opens HOD Assessment Form)" : "Approve Activity (Opens Assessment Form)"}
          >
            <CheckCircle2 className={`w-4 h-4 ${isHodContext ? "text-purple-600" : "text-emerald-600"}`} />
            <span>{isHodContext ? "HOD Approve" : "Approve"}</span>
          </button>

          <button
            onClick={handleRejectClick}
            disabled={processing}
            className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-bold text-xs transition-all bg-rose-50 text-rose-700 hover:bg-rose-100 border border-rose-300 shadow-xs w-full cursor-pointer ${
              processing ? "opacity-50 cursor-not-allowed" : ""
            }`}
            title={isHodContext ? "HOD Reject Activity (Opens HOD Assessment Form)" : "Reject Activity (Opens Assessment Form)"}
          >
            <XCircle className="w-4 h-4 text-rose-600" />
            <span>{isHodContext ? "HOD Reject" : "Reject"}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ReactionButtons;
